import { render, staticRenderFns } from "./RightsPage.vue?vue&type=template&id=eb45a0ec&scoped=true&"
import script from "./RightsPage.vue?vue&type=script&lang=js&"
export * from "./RightsPage.vue?vue&type=script&lang=js&"
import style0 from "./RightsPage.vue?vue&type=style&index=0&id=eb45a0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb45a0ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb45a0ec')) {
      api.createRecord('eb45a0ec', component.options)
    } else {
      api.reload('eb45a0ec', component.options)
    }
    module.hot.accept("./RightsPage.vue?vue&type=template&id=eb45a0ec&scoped=true&", function () {
      api.rerender('eb45a0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rights/RightsPage.vue"
export default component.exports